module.exports = __webpack_public_path__ + "static/media/zoneOn.6a7e9974.svg";